import { postDataAsync } from "./PortalApi";
import AuthResponse from "interfaces/response/AuthResponse";
import EmailAuthenticationVerificationRequest from "interfaces/request/EmailAuthenticationVerificationRequest";
import VerificationResponse from "interfaces/response/VerificationResponse";
import PhoneAuthenticationVerificationRequest from "interfaces/request/PhoneAuthenticationVerificationRequest";
import EmailSignInRequest from "interfaces/request/EmailSignInRequest";
import PhoneSignInRequest from "interfaces/request/PhoneSignInRequest";

export const requestEmailSignInAsync = async (data: EmailSignInRequest) => {
  const routeUrl = "Authentication/Email";
  return await postDataAsync<EmailSignInRequest, AuthResponse>(routeUrl, data);
};

export const requestPhoneSignInAsync = async (data: PhoneSignInRequest) => {
  const routeUrl = "Authentication/Phone";
  return await postDataAsync<PhoneSignInRequest, AuthResponse>(routeUrl, data);
};

export const requestForEmailAuthenticationVerificationAsync = async (
  data: EmailAuthenticationVerificationRequest
) => {
  const routeUrl = "Authentication/Email/VerificationCode";
  return await postDataAsync<
    EmailAuthenticationVerificationRequest,
    VerificationResponse
  >(routeUrl, data);
};

export const requestForPhoneAuthenticationVerificationAsync = async (
  data: PhoneAuthenticationVerificationRequest
) => {
  const routeUrl = "Authentication/Phone/VerificationCode";
  return await postDataAsync<
    PhoneAuthenticationVerificationRequest,
    VerificationResponse
  >(routeUrl, data);
};

export const requestForRefreshedAuthenticationTokenAsync = async () => {
  const routeUrl = "Authentication/Token/Refresh";
  return await postDataAsync<any, AuthResponse>(routeUrl, null);
};
